module.exports = __webpack_public_path__ + "media/site/images/products/saas_ceodash-f5bd7ca184b736dd5197b6e1dac2deda.png";